import { RequiredRule, Validator } from 'devextreme-react/validator';
import { DateBox } from 'devextreme-react/date-box';
import { useContext } from 'react';
import { Field, Panel } from '../../../../layouts';
import { AR, OrderStatus } from '../../../../types/enums';
import { formatDateWithTimeframe, TimeframeType } from '../../../../utils/date-utils';
import { RetailOrderContext } from '../context/RetailOrderContext';

export default function ActualMeasureDates() {

	const { order, modifyOrder } = useContext(RetailOrderContext);

	const isOrderReadonly =
		order.details.orderStatusID === OrderStatus.Closed ||
		order.details.orderStatusID === OrderStatus.Cancelled ||
		order.details.orderStatusID === OrderStatus.Pending ||
		order.details.orderStatusID === OrderStatus.Hold;

	let dateRequired = order.details.activeARs.includes(AR.CfiToEnterActualMeasureDate);
	let dateReadOnly = !dateRequired;

	return (
		<Panel header={'Dates'} >

			<Field label="Scheduled Measure Date">
				{formatDateWithTimeframe(order.details.measureDate, TimeframeType.Short)}
			</Field>
			<Field label="Actual Measure Date" >
				<DateBox value={order.details.actualMeasureDate}
					onValueChanged={(e) => modifyOrder({ ...order.details, actualMeasureDate: e.value })}
					readOnly={dateReadOnly || isOrderReadonly}
					className={dateRequired ? 'required' : ''}
					min={order.details.roDate}
					max={new Date()}>
					<Validator>
						{dateRequired && order.modified &&
							<RequiredRule message={'Actual Measure Date is required'} />}
					</Validator>
				</DateBox>
			</Field>
		</Panel>
	);
}
